import React from "react";
import cx from "classnames";
import { ButtonFullWidth } from "./Button";

const AddonButton = ({
  leftRounded,
  rightRounded,
  fullRounded,
  ...otherProps
}) => {
  return (
    <ButtonFullWidth
      className={cx("btn-blue h-full", {
        "rounded-sm lg:rounded-l-none lg:rounded-r-sm": rightRounded,
        "rounded-sm lg:rounded-r-none lg:rounded-l-sm": leftRounded,
        "rounded-sm": fullRounded,
      })}
      {...otherProps}
    />
  );
};

export default AddonButton;
